import { CategoryTable } from "./CategoryTable";
import { SearchBar } from "../Filters";
import { InputField } from "./AddCategoryForm";
import React, { useState, useEffect, useContext } from "react";
import { categoriesAPI, emailAPI, certificatesAPI } from "../../lib/apiService";
import { APIRequestContext } from "../../context";

function Category() {
  const [categories, setCategories] = useState([]);
  const { request_handler } = useContext(APIRequestContext);

  useEffect(() => {
    request_handler(async () => {
      const response = await categoriesAPI.getAll();
      const allCategories = response.data || response;
      setCategories(allCategories);
      return { data: { message: "Categories loaded successfully" } };
    });
  }, []);

  const onDelete = (category_id) => {
    request_handler(async () => {
      await categoriesAPI.delete(category_id);
      setCategories(
        categories.filter((cat) => {
          return cat.id !== category_id;
        })
      );
      
      return { data: { message: "Category deleted successfully" } };
    });
  };

  const onEdit = (edited_category, old_category) => {
    request_handler(async () => {
      const categoryData = {
        name: edited_category.name,
        description: edited_category.description
      };
      
      const response = await categoriesAPI.update(old_category.id, categoryData);
      const updatedCategory = response.data || response;
      
      // categories that are not edited
      let rest_categories = categories.filter((e) => {
        return e.id !== old_category.id;
      });
      setCategories([...rest_categories, updatedCategory]);
      
      return { data: { message: "Category edited successfully" } };
    });
  };

  const addCategory = (name) => {
    request_handler(async () => {
      const categoryData = {
        name: name,
        description: "", // Optional field
      };
      
      const response = await categoriesAPI.create(categoryData);
      const newCategory = response.data || response;
      setCategories([...categories, newCategory]);
      
      return { data: { message: "Category created successfully" } };
    });
  };

  const onMailSend = (category_id, send_all) => {
    request_handler(async () => {
      const emailData = {
        send_all: send_all,
        category: category_id,
      };
      
      const response = await emailAPI.sendBulkEmails(emailData);
      return response;
    });
  };

  const onRegenerate = (category_id, template, mapping) => {
    request_handler(async () => {
      // This would need to be implemented based on the new certificate generation endpoint
      const response = await certificatesAPI.generateBulk(null, template, mapping);
      return response;
    });
  };

  return (
    <div className="event-wrapper">
      <div className="add-item-form">
        <InputField addCategory={addCategory} />
      </div>
      <div className="search-and-sort">
        <SearchBar />
      </div>
      <div className="list-view">
        <CategoryTable
          // event_id={event_id}
          categories={categories}
          onDelete={onDelete}
          onEdit={onEdit}
          onMailSend={onMailSend}
          onRegenerate={onRegenerate}
        />
      </div>
    </div>
  );
}

export default Category;
